<template>
  <div style="max-width: 900px">

    <div class="list-group" style="">
      <a href="#" class="list-group-item list-group-item-action flex-column align-items-start" v-for="(item,index) in formData.EventItems" :key="index">
        <div class="d-flex w-100 justify-content-between">
          <h5 class="mb-1">{{item.Name}}</h5>
          <small>
            <span v-if="item.IsJoin==='1'">
              已報名
            </span>
            <span v-else-if="item.IsJoin==='0'">
              未報名
            </span>

            <span v-if="item.IsCheckIn==='1'">
              已報到
            </span>
            <span v-else-if="item.IsCheckIn==='0'">
              未報到
            </span>
          </small>
        </div>
<!--        <p class="mb-1"></p>-->

        <div v-if="item.Question1" class="question">
          問題1 {{ item.Question1}} <br>
          報到回覆: {{item.Question1Answer}}
<!--          <MyRadioWithTokenStr v-model="item.Question1Answer" :option-token-str="item.Question1Options" token-str=","></MyRadioWithTokenStr>-->
        </div>
        <hr>
        <div v-if="item.Question2" class="question">
          問題2 {{ item.Question2}} <br>
          報到回覆:  {{item.Question2Answer}}
<!--          <MyRadioWithTokenStr v-model="item.Question2Answer" :option-token-str="item.Question2Options" token-str=","></MyRadioWithTokenStr>-->
        </div>
        <hr>
        <div v-if="item.Question3" class="question">
          問題3 {{item.Question3}} <br>
          報到回覆:  {{item.Question3Answer}}
<!--          <MyRadioWithTokenStr v-model="item.Question3Answer" :option-token-str="item.Question3Options" token-str=","></MyRadioWithTokenStr>-->
        </div>

        <small>


        </small>
      </a>
    </div>

<!--        <table class="table table-hover" id="tblMain">-->
<!--          <thead class="thead-light">-->
<!--          <tr>-->
<!--            <th>場次名稱</th>-->
<!--            <th>類型</th>-->
<!--            <th>報名</th>-->
<!--            <th>報到</th>-->
<!--            <th>回覆</th>-->
<!--            &lt;!&ndash;            <th>備註</th>&ndash;&gt;-->
<!--          </tr>-->
<!--          </thead>-->
<!--          <tbody>-->
<!--          <tr v-for="(item,index) in formData.EventItems" :key="index">-->
<!--            <td width="200px">-->
<!--              {{item.Name}}-->
<!--            </td>-->
<!--            <td width="200px">-->
<!--              <div v-if="item.Type===CheckIn_EventItemType_Open">-->
<!--                開放型(不需預先報名)-->
<!--              </div>-->
<!--              <div v-else-if="item.Type===CheckIn_EventItemType_NeedReg">-->
<!--                需先報名-->
<!--              </div>-->
<!--              <div v-else>-->
<!--                XX:{{item.Type}}-->
<!--              </div>-->
<!--            </td>-->
<!--            <td>-->
<!--&lt;!&ndash;              <label class="radio-inline"><input type="radio" :name="'r1'+item.Name" :value="'1'" v-model="item.IsJoin">是</label>&ndash;&gt;-->
<!--&lt;!&ndash;              <label class="radio-inline"><input type="radio" :name="'r1'+item.Name" :value="'0'" v-model="item.IsJoin">否</label>&ndash;&gt;-->

<!--              <div v-if="item.IsJoin==='1'">-->
<!--                  是-->
<!--              </div>-->
<!--              <div v-else-if="item.IsJoin==='0'">-->
<!--                  否-->
<!--              </div>-->

<!--            </td>-->
<!--            <td>-->
<!--&lt;!&ndash;              <label class="radio-inline"><input type="radio" :name="'r2'+item.Name" :value="'1'" v-model="item.IsCheckIn">是</label>&ndash;&gt;-->
<!--&lt;!&ndash;              <label class="radio-inline"><input type="radio" :name="'r2'+item.Name" :value="'0'" v-model="item.IsCheckIn">否</label>&ndash;&gt;-->
<!--&lt;!&ndash;              <br>&ndash;&gt;-->
<!--&lt;!&ndash;              簽到者:{{item.CheckInExecBy}}&ndash;&gt;-->

<!--              <div v-if="item.IsCheckIn==='1'">-->
<!--                是-->
<!--              </div>-->
<!--              <div v-else-if="item.IsCheckIn==='0'">-->
<!--                否-->
<!--              </div>-->
<!--            </td>-->
<!--            <td>-->
<!--              <div v-if="item.Question1">-->
<!--              問題1 {{ item.Question1}} <br>-->
<!--              報到回覆:  <MyRadioWithTokenStr v-model="item.Question1Answer" :option-token-str="item.Question1Options" token-str=","></MyRadioWithTokenStr>-->
<!--              </div>-->
<!--              <hr>-->
<!--              <div v-if="item.Question2">-->
<!--              問題2 {{ item.Question2}} <br>-->
<!--              報到回覆:  <MyRadioWithTokenStr v-model="item.Question2Answer" :option-token-str="item.Question2Options" token-str=","></MyRadioWithTokenStr>-->
<!--              </div>-->
<!--              <hr>-->
<!--              <div v-if="item.Question3">-->
<!--              問題3 {{item.Question3}} <br>-->
<!--              報到回覆:  <MyRadioWithTokenStr v-model="item.Question3Answer" :option-token-str="item.Question3Options" token-str=","></MyRadioWithTokenStr>-->
<!--              </div>-->
<!--            </td>-->
<!--          </tr>-->
<!--&lt;!&ndash;          <tr>&ndash;&gt;-->
<!--&lt;!&ndash;            <td>問題1 {{ item.Question1}}</td>&ndash;&gt;-->
<!--&lt;!&ndash;            <td>回覆:<MyRadioWithTokenStr v-model="item.Question1Answer" :option-token-str="item.Question1Options" token-str=","></MyRadioWithTokenStr></td>&ndash;&gt;-->
<!--&lt;!&ndash;          </tr>&ndash;&gt;-->
<!--&lt;!&ndash;          <tr>&ndash;&gt;-->
<!--&lt;!&ndash;            <td>問題2 {{ item.Question1}}</td>&ndash;&gt;-->
<!--&lt;!&ndash;            <td>回覆:<MyRadioWithTokenStr v-model="item.Question1Answer" :option-token-str="item.Question1Options" token-str=","></MyRadioWithTokenStr></td>&ndash;&gt;-->
<!--&lt;!&ndash;          </tr>&ndash;&gt;-->
<!--&lt;!&ndash;          <tr>&ndash;&gt;-->
<!--&lt;!&ndash;            <td>問題3 {{ item.Question1}}</td>&ndash;&gt;-->
<!--&lt;!&ndash;            <td>回覆:<MyRadioWithTokenStr v-model="item.Question1Answer" :option-token-str="item.Question1Options" token-str=","></MyRadioWithTokenStr></td>&ndash;&gt;-->
<!--&lt;!&ndash;          </tr>&ndash;&gt;-->
<!--          </tbody>-->
<!--        </table>-->
  </div>
</template>



<script>
/**
 <UIEventItems :member="formData"  :event-system-id="EventSystemId"></UIEventItems>
 **/
import util from "@/util/util";
import apiAdmin from "@/views/taylorAdmin/js/apiAdmin";
import {CheckIn_EventItemType_Open,CheckIn_EventItemType_NeedReg} from "@/views/checkInAdmin/js/checkInDeclare";
import apiCheckIn from "@/views/checkInAdmin/js/apiCheckIn";
import MyRadioWithTokenStr from "@/views/taylorAdmin/component/MyRadioWithTokenStr";

export default {
  components: {MyRadioWithTokenStr},
  props: ['Member'], //tag  postTitle="hi"  data this.postTitle
  data: function () {
    return {
      CheckIn_EventItemType_Open:CheckIn_EventItemType_Open,
      CheckIn_EventItemType_NeedReg:CheckIn_EventItemType_NeedReg,
      // type: "",
      formData: {
        Name: "",
        Memo:"",
        EventItems:[],
      },
      formDataValidate: {
        Name: "required",
        Memo:"",
      },
      // formDataJoin:[
      //   {
      //     EventSystemId:"",
      //     EventItemSystemId:"",
      //     Question1Answer:"",
      //     Question1Answer:"",
      //     Question1Answer:"",
      //   }
      // ]
      MemberDataFormSave:{},
    };
  },
  methods: {
    getItem:function(){
      let that=this

      let loader=util.ShowLoading(this);

      if (this.Member.EventSystemId){
        apiCheckIn.api_Event_Get(this.Member.EventSystemId).then((data)=>{
          that.formData=apiAdmin.initReturnObjectWithTemplate(data.data.data,this.formData);

          that.formData.EventItems.forEach((item)=>{
            item.IsJoin=false;//虛擬欄位:預設沒報名
            item.IsCheckIn=false;
            item.CheckInExecBy="";
            item.Question1Answer="";
            item.Question2Answer="";
            item.Question3Answer="";
          });

          that.formData.EventItems.forEach((item)=>{

            let eventItem=that.Member.EventItems.find(s => s.EventItemSystemId===item.SystemId);
            if (eventItem){
              item.IsJoin=eventItem.IsJoin;
              item.IsCheckIn=eventItem.IsCheckIn;
              item.CheckInExecBy=eventItem.CheckInExecBy;
              item.Question1Answer=eventItem.Question1Answer;
              item.Question2Answer=eventItem.Question2Answer;
              item.Question3Answer=eventItem.Question3Answer;
            }
          });
          //
          // that.Member.EventItems.forEach((item)=>{
          //
          //   let eventItem=that.formData.EventItems.find(s => s.SystemId===item.EventItemSystemId);
          //
          //   if (eventItem){
          //     item.IsJoin=eventItem.IsJoin;
          //     item.IsCheckIn=eventItem.IsCheckIn;
          //     item.CheckInExecBy=eventItem.CheckInExecBy;
          //     item.Question1Answer=eventItem.Question1Answer;
          //     item.Question2Answer=eventItem.Question2Answer;
          //     item.Question3Answer=eventItem.Question3Answer;
          //   }
          // });

          util.HideLoading(loader);
        });
      }else{
        util.HideLoading(loader);
      }
    },
    getMemberEventItemsDataForSave(){
      let eventItemsReturn=[];

      this.formData.EventItems.forEach((item)=>{
        let eventItem={
          EventSystemId:this.Member.EventSystemId,
          EventItemSystemId:item.SystemId,
          IsJoin:item.IsJoin,
          IsCheckIn:item.IsCheckIn,
          CheckInExecBy:item.CheckInExecBy,
          Question1Answer:item.Question1Answer,
          Question2Answer:item.Question2Answer,
          Question3Answer:item.Question3Answer,
        }

        eventItemsReturn.push(eventItem);
      })

      return eventItemsReturn;
    }
  },
  mounted() {
    this.getItem()
  },
}
</script>

<style scoped>
.question{
  margin-left:30px;
}
.table{
  color:white;
  background-color:#00375e;
  border-color:#00375e;
}
.table .thead-light th{
  color:white;
  background-color:#00375e;
  border-color:#00375e;
}
.list-group-item{
  background-color: #00375e;
  color:white;
}
</style>
